export default "__VITE_ASSET__DrhaKvGV__"